import { LINE_BREAK_PLUGIN_ID } from '../plugins/lineBreak/types';
import { ParagraphPluginElement } from '../slate-custom-types';
import { walkSlateContent } from './walkSlateContent';
import { Element, Node } from 'slate';

/**
 * Converts slate report content to a string representation for visualization purposes.
 * This function differs from slateContentToString in that it does some additional removals
 * for the purpose of visualization.
 */
export const slateToString = <T extends Node>(nodes: ReadonlyArray<T>): string => {
  let contentString = '';

  const getTextString = (node: Node): void => {
    contentString += Node.string(node)
      .replace(/nbsp;/gi, ' ')
      .replace(/&lt;br&gt;/gi, '<br>')
      .replace(/(<br>|<br \/>)/gi, '\n')
      .replace(/<[a-zA-Z./].*>/gi, '');
  };

  const appendNodeString = (node: Node): void => {
    if (Element.isElement(node) && node.type === LINE_BREAK_PLUGIN_ID) {
      contentString += '\n';
    }
  };

  for (const [index, node] of Array.from(nodes.entries())) {
    walkSlateContent(appendNodeString, getTextString)(node);
    const nextNode = index < nodes.length - 1 ? nodes[index + 1] : null;
    contentString += (nextNode as ParagraphPluginElement)?.shouldForceInline === true ? '' : '\n';
  }

  return contentString;
};
